<section class="profile-page">
  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="profile-hero">
    <div class="profile-avatar">{{ displayName.charAt(0) }}</div>
    <div>
      <h1>{{ displayName }}</h1>
      <span *ngIf="loading">Загружаем профиль...</span>
      <span *ngIf="!loading && me">{{ me.username }} • {{ getRoleLabel(me.role) }}</span>
    </div>
  </section>

  <section class="profile-summary" *ngIf="me as user">
    <article>
      <span>Роль</span>
      <strong>{{ getRoleLabel(user.role) }}</strong>
    </article>
    <article>
      <span>Статус</span>
      <strong>{{ user.isActive ? 'Активен' : 'Заблокирован' }}</strong>
    </article>
    <article>
      <span>Права</span>
      <strong>{{ permissionCount }}</strong>
    </article>
    <article>
      <span>Telegram ID</span>
      <strong>{{ user.telegramId || '-' }}</strong>
    </article>
  </section>

  <section class="profile-grid" *ngIf="me as user">
    <article class="profile-panel">
      <div class="panel-title">
        <h2>Данные профиля</h2>
        <span>Эта информация относится только к вашему аккаунту.</span>
      </div>

      <label>
        <span>Отображаемое имя</span>
        <input type="text" [(ngModel)]="profileDisplayName" placeholder="Например: Иван А.">
      </label>

      <dl class="profile-meta">
        <div>
          <dt>Логин</dt>
          <dd>{{ user.username }}</dd>
        </div>
        <div>
          <dt>Создан</dt>
          <dd>{{ formatDate(user.createdAt) }}</dd>
        </div>
        <div>
          <dt>Обновлен</dt>
          <dd>{{ formatDate(user.updatedAt) }}</dd>
        </div>
      </dl>

      <button type="button" class="action-button primary" (click)="saveProfile()">Сохранить профиль</button>
    </article>

    <article class="profile-panel">
      <div class="panel-title">
        <h2>Смена пароля</h2>
        <span>Пароль меняется только для текущего профиля.</span>
      </div>

      <div class="password-grid">
        <label>
          <span>Текущий пароль</span>
          <input type="password" [(ngModel)]="currentPassword">
        </label>
        <label>
          <span>Новый пароль</span>
          <input type="password" [(ngModel)]="nextPassword">
        </label>
      </div>

      <button type="button" class="action-button" (click)="changeOwnPassword()">Обновить пароль</button>
    </article>

    <article class="profile-panel api-panel" *ngIf="isAdmin">
      <div class="panel-title">
        <h2>API Bearer-token</h2>
        <span>Доступен только администратору.</span>
      </div>

      <div class="token-preview">
        <span>Текущий token</span>
        <strong>{{ user.apiTokenPreview || 'Не создан' }}</strong>
      </div>

      <div class="token-preview">
        <span>Создан</span>
        <strong>{{ formatDate(user.apiTokenCreatedAt) }}</strong>
      </div>

      <div class="token-preview">
        <span>Последнее использование</span>
        <strong>{{ formatDate(user.apiTokenLastUsedAt) }}</strong>
      </div>

      <div class="token-output" *ngIf="newApiToken">
        <span>Новый token показывается один раз</span>
        <code>Bearer {{ newApiToken }}</code>
        <button type="button" class="action-button" (click)="copyApiToken()">Скопировать</button>
      </div>

      <button type="button" class="action-button danger-soft" (click)="refreshApiToken()">Обновить token</button>
    </article>
  </section>
</section>
